import { CaretDown, Plus } from '@phosphor-icons/react';
import { Button, Collapser, Search, Toggle, VText } from '@vake/ui-kit';
import { FC, useRef, useState } from 'react';
import { ReportsTable, ReportType } from './reports-table';
import { useClickOutside } from '../../../utils/click-outside';
import { addReportKindSymbol } from '../../../utils/report-kind-icons';
import { ReportFilterComponents } from './report-filters';

const MenuCreate: FC = () => {
    return (
        <div className="flex flex-col gap-2 p-4 bg-background-secondary rounded-md border-label-tertiary border-2">
            <div className="flex gap-2">
                {addReportKindSymbol('overwatch')}
                <VText variant="D1">Overwatch</VText>
            </div>
            <div className="flex gap-2">
                {addReportKindSymbol('pathfinder')}
                <VText variant="D1">Pathfinder</VText>
            </div>
            <div className="flex gap-2">
                {addReportKindSymbol('clearview')}
                <VText variant="D1">Clearview</VText>
            </div>
        </div>
    );
};

const PFReports = () => {
    const [openCreateNew, setOpenCreateNew] = useState<boolean>(false);
    const wrapperRef = useRef<HTMLDivElement>(null);
    const [searchQuery, setSearchQuery] = useState<string>('');
    const [filterReportType, setFilterReportType] = useState<ReportType[]>(['Pathfinder', 'Overwatch']);

    useClickOutside(wrapperRef, setOpenCreateNew);

    return (
        <div className="p-8 ">
            <div id="upper-element">
                <div className="flex justify-between">
                    <VText variant="T2">All reports across teams</VText>
                    <div>
                        <Button
                            text="Create new"
                            iconBefore={<Plus />}
                            iconAfter={<CaretDown />}
                            onClick={() => setOpenCreateNew(!openCreateNew)}
                        />
                        {openCreateNew && (
                            <div ref={wrapperRef} className="absolute mt-1">
                                <MenuCreate />
                            </div>
                        )}
                    </div>
                </div>

                <div className="mt-4 w-[400px]">
                    <Search
                        placeholder={'Search by name, mmsi...'}
                        query={searchQuery}
                        handleChange={setSearchQuery}
                        regexFilterOut={/[^ a-zA-Z0-9]/g}
                    />
                </div>
                <div className="flex py-4 justify-between">
                    <ReportFilterComponents
                        filterReportType={filterReportType}
                        setFilterReportType={setFilterReportType}
                    />
                </div>
            </div>
            <ReportsTable searchQuery={searchQuery} filterReport={filterReportType} />
        </div>
    );
};

export default PFReports;
